<template>
  <div>
    <!--    // 确定收款-->
    <a-modal
      title="确认收款"
      style="top: 20px;"
      :width="800"
      v-model="collectionible"
      :confirmLoading="confirmLoading"
      @ok="collectionConfirm"
      okText="确认收款"
    >
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需支付">
          <a-input v-model="needpayAmount" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际支付">
          <a-input v-model="actualpayAmount" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="未支付">
          <a-input v-model="Unpaid" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付方式">
          <a-select>
            <a-select-option v-for="type in installTypes" :key="type.code">{{ type.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input v-decorator="['updateBy']" />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--    // 退款-->
    <a-modal
      title="退款"
      style="top: 20px;"
      :width="800"
      v-model="refundible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
    >
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际收款">
          <a-input v-model="realReceipts" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="退款">
          <a-input v-model="refund" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="余额">
          <a-input v-model="balance" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付方式">
          <a-select>
            <a-select-option v-for="type in installTypes" :key="type.code">{{ type.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input
            type="textarea"
            v-decorator="['note', { rules: [{ required: true, message: '请输入备注信息!' }] }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--    // 备注-->
    <a-modal
      title="备注"
      style="top: 20px;"
      :width="800"
      v-model="remarkible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
    >
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="添加备注">
          <a-input v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { STable } from '@/components'
// 导入弹框vue
import EnterpriseModal from '../modules/CustomerModal.vue'
import EnterGenerateModal from '../modules/enterGenerateModal.vue'
// 调接口
import { getConfirmList, getRefundList } from '@/api/finance/CustomerExpense'
import { saveBrand } from '@/api/enterprise/brand'
import pick from 'lodash.pick'
import { getDictMap } from '../../../utils/dict'
export default {
  name: 'BrandModal',
  props: {},
  components: {
    STable,
    // 注册弹框组件
    EnterpriseModal,
    EnterGenerateModal
  },
  data() {
    return {
      // 实际收款
      realReceipts: '',
      // 退款
      refund: '',
      // 需要支付金额返回的数据
      needpayAmount: '',
      // 实际支付金额
      actualpayAmount: '',
      visible: false,
      // 确定收款
      confirmReceiptible: false,
      // 退款
      refundible: false,
      // 备注
      remarkible: false,
      // 字典为支付方式
      installTypes: [],
      // 确认收款返回参数
      confirmlist: [],
      // 退款返回参数
      refundList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this)
    }
  },
  beforeCreate() {},
  computed: {
    Unpaid() {
      let Unpaidnum = this.needpayAmount - this.actualpayAmount
      return Unpaidnum
    },
    balance() {
      let Unpaidnum = this.ealReceipts - this.refund
      return Unpaidnum
    }
  },
  async created() {
    // 字典为支付方式
    this.installTypes = []
    this.restaurantOperTypeMap = await getDictMap('pay_method')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.installTypes.push({ code: key, label: value })
    })
  },
  methods: {
    add() {
      this.form.resetFields()
      this.edit({ brandId: 0 })
    },
    edit(record) {
      this.mdl = Object.assign(record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.mdl,
            'brandId',
            'brandName',
            'installType',
            'delFlag',
            'forbiddenStatus',
            'createBy',
            'createTime',
            'updateBy',
            'updateTime'
          )
        )
      })
    },
    // 确定收款
    confirmReceipt(id) {
      this.confirmReceiptible = true
      getConfirmList({ orderId: id }).then(res => {
        if (res.code === 0) {
          // // 响应的数据
          this.realReceipts = res.data
          // console.log(this.needpayAmount)
        }
      })
      // console.log(id)
    },
    // 退款
    confirmRefund(id) {
      this.refundible = true
      getRefundList({ orderId: id }).then(res => {
        if (res.code === 0) {
          // // 响应的数据
          this.needpayAmount = res.data
          // console.log(this.needpayAmount)
        }
      })
      console.log(id)
    },
    // 备注
    remark(record) {
      this.remarkible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(record, 'remark'))
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          this.confirmLoading = true
          saveBrand(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok')
                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
